// export const days: { [key: string]: string } = {
//     Monday: 'Lundi',
//     Tuesday: 'Mardi',
//     Wednesday: 'Mercredi',
//     Thursday: 'Jeudi',
//     Friday: 'Vendredi',
//     Saturday: 'Samedi',
//     Sunday: 'Dimanche'
// };
export enum days {
    Monday = 'Lundi',
    Tuesday = 'Mardi',
    Wednesday = 'Mercredi',
    Thursday = 'Jeudi',
    Friday = 'Vendredi',
    Saturday = 'Samedi',
    Sunday = 'Dimanche'
}

export type day = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'